export default __webpack_public_path__ + "static/media/learn-more-desktop.cdb5d320.png";